import { render, staticRenderFns } from "./ModificationsComponent.vue?vue&type=template&id=b2c1cf54&lang=pug&"
import script from "./ModificationsComponent.vue?vue&type=script&lang=js&"
export * from "./ModificationsComponent.vue?vue&type=script&lang=js&"
import style0 from "./ModificationsComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports